module.exports = __webpack_public_path__ + "static/img/application_img8.bc6b1fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application_img8.jpg
// module id = nz7b
// module chunks = 0